<template>
    <v-main>
        <AppBar :back="customBack" />
        <v-layout fill-height column>
            <v-container flex-fill fluid class="pt-0">
                <ul class="purchase-history">
                    <li v-for="(item, index) in orderList" :key="index">
                        <div class="fs-12 secondary--text mb-2" v-if="item.ordStatus === '01'">
                            {{ item.ordDt }}
                            <span class="fw-600 info--text ml-2" v-if="item.deliveryStatus === null">결제 완료</span>
                            <span class="fw-600 info--text ml-2" v-if="item.deliveryStatus !== null">{{ item.deliveryStatusNm }}</span>
                        </div>
                        <div class="fs-12 secondary--text mb-2" v-if="item.ordStatus === '03' || item.ordStatus === '04'">
                            {{ item.ordCancelDt }}
                            <span class="fw-600 error--text ml-2" >취소완료</span>
                            <span v-if="item.ordStatus === '02'" class="fw-600 error--text ml-2" >취소요청</span>
                        </div>
                        <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">{{item.goodsClsfNm}}</span>{{ item.goodsNm }}</div>
                        <div class="secondary--text mt-2"></div>
                        <div class="fs-16 fw-700 primary--text line-height-1 mt-6" >{{ item.paymentAmt }}원</div>
                        <div>
                            <v-btn v-if="((item.ordStatus === '01' || item.ordStatus === '06')
                                        && ((item.deliveryStatus === null && item.goodsClsfNm==='물성')) || (item.ordStatus === '01' && item.goodsClsfNm === '티켓' && item.rtEp <= 2))" plain :ripple="false" height="48" width="100%" class="btn-cancel mt-6" @click="moveOrderCancel(item.ordNo)">구매취소</v-btn>
                            <v-btn v-if="(item.ordStatus === '01' || item.ordStatus === '06')
                                        && ((item.deliveryStatus >='02' && item.goodsClsfNm==='물성'))" plain :ripple="false" height="48" width="100%" class="btn-cancel mt-6">배송조회</v-btn>
                        </div>
                       
                        <v-btn plain text :ripple="false" color="#C7C7C7" height="20" class="btn-details" @click="moveOrderDetail(item.ordNo)">상세보기 <img :src="getImage('ic_arrow_right.svg')" class="ml-3"/></v-btn>
                    </li>
                </ul>
                <div v-if="orderList.length == 0" class="ticket no-data">
                <div>
                    구매내역이 없습니다.
                </div>
                </div>
            </v-container>
        </v-layout>
    </v-main>
</template>
<script>
import store from '@/store'
import moment from "moment";
moment.locale("ko");
export default {
    data: () => ({
        orderList:[],
        isCancel: false
    }),
    created(){
        this.orderHistoryDetails();
    },
    methods:{
        async orderHistoryDetails(){
            await store.dispatch('orderHistoryDetails', this.$_payload({}))
            .then(res => {
               console.log(res);
               this.orderList = res.data;
            })
            .catch(error => {
                console.error(error)

            })
            .finally(() => {

            })
        },
        moveOrderDetail(ordNo){
            this.$router.push({name: "구매 상세", query: {ordNo: ordNo}});
        },
        moveOrderCancel(ordNo){
            this.$confirm('구매 취소하시겠습니까?', {
                persistent: false,
                showClose: true,
                actions: {
                false: {text: '아니오'},
                true: {text: '구매 취소하기'}
                }
            }).then(result => {
                if(result){
                    //티켓 사용
                   this.$router.push({name:"구매취소", query: {ordNo: ordNo}});
                }
            })
        },
        customBack () {
            this.movePage('/fo/suitcase');
        },

    },
    filters:{
        comma(val){
            return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
}
</script>
<style lang="scss" scoped>
.purchase-history {
    padding-left: 0px;
    li {
        position: relative;
        border-top: 1px solid #E6E8EA;
        padding: 30px 0;
        cursor: pointer;
        &:first-child {
            border-top:none;
        }
    }
}
.badge {
    border: 1px solid $color-main;
    padding: 0 10px;
    height: 22px;
    font-size: 12px;
    font-weight: 500;
    color: $color-main;
    background: transparent;
    border-radius: 20px;
    width: auto;
    flex-shrink: 0;
}
.btn-cancel {
    padding-top: 10%;
    background-color: white !important;
    border:1px solid rgb(159 163 168) !important;
}
.btn-details {
    position: absolute;
    top: 29px;
    right: 0;
    font-size: 12px;
    font-weight: 400;
    padding: 0 5px;
}
</style>
